export const baseURL = "https://crmred.co/"
//export const baseURL = "http://redcrm.test/"
// export const baseURL = "http://192.168.10.243:8000/"
//export const baseURL = "https://redcrm.local/"
export const settings = {
  some: 'Settings'
}
